import React, { useState } from "react";
import { useFieldArray, useFormContext } from "react-hook-form";
import { GridLegacy, IconButton, List, ListItem, Typography } from "@mui/material";
import TranslationWrapper, { getTranslation } from "../../../../components/TranslationWrapper/TranslationWrapper";
import Card from "../../../../components/Card/Card";
import CardBody from "../../../../components/Card/CardBody";
import AsynchronousAutocomplete from "../../../../components/Autocomplete/AsynchronousAutocomplete";
import Tooltip from "@mui/material/Tooltip";
import Button from "../../../../components/CustomButtons/Button";
import { Link } from "react-router";
import Edit from "@mui/icons-material/Edit";
import { Delete } from "@mui/icons-material";

export default function ArrangementGroups() {
  const { control } = useFormContext();
  const { fields, append, prepend, remove, swap, move, insert } = useFieldArray({
    control,
    name: "arrangement_groups",
    keyName: "key",
  });

  return (
    <Card>
      <CardBody style={{ padding: 16 }}>
        <GridLegacy container spacing={1}>
          <GridLegacy item xs={12}>
            <List
              sx={{
                "& li:nth-child(even)": {
                  backgroundColor: "#eee",
                },
              }}
            >
              <ListItem>
                <GridLegacy container>
                  <GridLegacy item xs={6}>
                    <TranslationWrapper tKey={"Arrangement Group"} />
                  </GridLegacy>
                  <GridLegacy item xs={6} />
                </GridLegacy>
              </ListItem>

              {fields.map((field, index) => {
                return (
                  <ListItem>
                    <GridLegacy container>
                      <GridLegacy item sx={{ display: "grid", alignItems: "center" }} xs={6}>
                        <Typography>{field.name}</Typography>
                      </GridLegacy>

                      <GridLegacy item xs={6}>
                        <IconButton
                          onClick={() => {
                            remove(index);
                          }}
                        >
                          <Delete />
                        </IconButton>

                        {/*<Link to={`/manager/producten/${field.id}/edit`}>*/}
                        {/*  <Tooltip*/}
                        {/*    title={*/}
                        {/*      <TranslationWrapper tKey={"global.jamezzTable.viewProduct"} tDefault={"View Product"} />*/}
                        {/*    }*/}
                        {/*    placement="bottom"*/}
                        {/*    classes={{}}*/}
                        {/*  >*/}
                        {/*    <Button color="success" simple>*/}
                        {/*      <Edit />*/}
                        {/*    </Button>*/}
                        {/*  </Tooltip>*/}
                        {/*</Link>*/}
                      </GridLegacy>
                    </GridLegacy>
                  </ListItem>
                );
              })}
            </List>
          </GridLegacy>
        </GridLegacy>

        <AddChildProduct append={append} />
      </CardBody>
    </Card>
  );
}

function AddChildProduct({ append }) {
  const { register, vestigingId, menukaartVestigingId, reloadDataFromServer } = useFormContext();
  const [product, setProduct] = useState(null);
  return (
    <>
      <AsynchronousAutocomplete
        async={{
          url: `core/arrangementGroups/search?fields=id as value,id,name as label,vestiging_id,name&sort_field=name&sort_dir=asc&vestiging_id=${vestigingId}`,
          searchField: "name",
          perPage: 20,
          // extraFilters: { vestiging_id: { name: "vestiging_id", value: "vestiging_id" } },
        }}
        key={menukaartVestigingId}
        onChange={(e, option) => {
          setProduct(option);
        }}
        placeholder={getTranslation("Find group")}
        value={product}
      />
      <Button
        disabled={!product}
        onClick={() => {
          setProduct(null);
          append(product);
        }}
      >
        <TranslationWrapper tKey={"Add group"} />
      </Button>
    </>
  );
}
